import Video3 from './Video3'
export default Video3
